// Runtime configuration derived from build-time VITE_* vars + URL params.

const params = new URLSearchParams(window.location.search);

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

// Known Randori parent domains. Merged with the build-time VITE_PARENT_ORIGIN so
// the height-sync keeps working even if that env var is missing a variant (e.g.
// the www. host, or the hyphen domain randori-pro.de vs randori.pro). A wrong or
// incomplete allowlist would make postMessage target the wrong origin, which the
// browser drops silently → the iframe stays stuck at its min-height.
const DEFAULT_PARENT_ORIGINS = [
  'https://randori-pro.de',
  'https://www.randori-pro.de',
  'https://randori.pro',
  'https://www.randori.pro',
];

// Werbekanal-Attribution: das WP-Embed-Snippet haelt die utm_*-Parameter des
// Besuchs fest und haengt sie an die iframe-URL an; hier lesen wir sie aus und
// geben sie beim Step-1-Capture als versteckte Felder mit (Server kuerzt/
// bereinigt nochmal). Nur die fuenf Standard-UTM-Keys, keine Click-IDs.
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;
export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;
const utm: UtmParams = {};
for (const key of UTM_KEYS) {
  const value = params.get(key)?.trim();
  if (value) utm[key] = value.slice(0, 200);
}

export const config = {
  supabaseUrl,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
  // Allowlist der Eltern-Domains für den postMessage-Höhen-Sync. Komma-getrennt
  // aus VITE_PARENT_ORIGIN, ergänzt um die bekannten Randori-Domains, damit
  // dasselbe Widget auf mehreren unserer Domains eingebettet werden kann
  // (z. B. randori-pro.de UND randori.pro, jeweils mit/ohne www).
  parentOrigins: [
    ...new Set([
      ...(import.meta.env.VITE_PARENT_ORIGIN ?? '')
        .split(',')
        .map((s: string) => s.trim())
        .filter(Boolean),
      ...DEFAULT_PARENT_ORIGINS,
    ]),
  ],
  functionsUrl: import.meta.env.VITE_FUNCTIONS_URL || `${supabaseUrl}/functions/v1`,
  // Test mode: ?test=1 on the iframe src (or a dedicated test deployment).
  isTest: params.get('test') === '1',
  // Confirmation link from the holiday pre-booking reminder mail: ?confirm=<token>
  confirmToken: params.get('confirm'),
  // Storno-Link aus der Bestätigungs-/Erinnerungs-Mail: ?cancel=<token>
  cancelToken: params.get('cancel'),
  // Herkunft des Besuchs (utm_*), vom Embed-Snippet durchgereicht.
  utm,
} as const;

// Cloudflare's always-pass test site key — used in test mode when no real key
// is configured, so the flow runs without a real challenge.
export const TURNSTILE_TEST_SITEKEY = '1x00000000000000000000AA';

export const effectiveTurnstileSiteKey = (): string | undefined =>
  config.turnstileSiteKey || (config.isTest ? TURNSTILE_TEST_SITEKEY : undefined);
